module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./WorkWxVerifyView.js"));
	}, "WorkWxVerifyView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=WorkWxVerifyView!./src/pages/Login/WorkWxVerify/WorkWxVerifyView.js
// module id = 840
// module chunks = 438